import { render, staticRenderFns } from "./BrowseCatalogueProviders.vue?vue&type=template&id=2dc8c218&scoped=true"
import script from "./BrowseCatalogueProviders.vue?vue&type=script&lang=js"
export * from "./BrowseCatalogueProviders.vue?vue&type=script&lang=js"
import style0 from "./BrowseCatalogueProviders.vue?vue&type=style&index=0&id=2dc8c218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8c218",
  null
  
)

export default component.exports